import coralRightType1 from '../../assets/new-ui/coral/coral-right-type-1.gif'

export default function CoralRightType1(props) {
  const {type} = props
  return (
    <div className={type==='big' ? 'coralGif coralRightType1 coralRightType1Big' : 'coralGif coralRightType1 coralRightType1Small'} >
      <img src={coralRightType1} alt='coral gif' />
    </div>
  )
}